import React from "react";

type Props = {};

const CheckedLang = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
  <path d="M7.77202 0H2.22222C1.00173 0 0 1.04366 0 2.31525V10.7665C0 11.8462 0.74266 12.302 1.65227 11.7802L4.46172 10.1547C4.76108 9.98078 5.24467 9.98078 5.53828 10.1547L8.34773 11.7802C9.25734 12.308 10 11.8522 10 10.7665V2.31525C9.99424 1.04366 8.99827 0 7.77202 0ZM7.08117 4.27062L4.77835 6.66985C4.692 6.75982 4.58261 6.80181 4.47323 6.80181C4.36385 6.80181 4.25446 6.75982 4.16811 6.66985L3.30455 5.77014C3.22425 5.68548 3.17922 5.57126 3.17922 5.45224C3.17922 5.33322 3.22425 5.219 3.30455 5.13434C3.4715 4.9604 3.74784 4.9604 3.9148 5.13434L4.47323 5.71616L6.47093 3.63483C6.63788 3.46088 6.91422 3.46088 7.08117 3.63483C7.24813 3.80877 7.24813 4.09668 7.08117 4.27062Z" fill="#3B82F6"/>
</svg>
  );
};

export default CheckedLang;
